import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import heroBg from "@/assets/hero-bg.jpg";
import { BookOpen, Users, Leaf, Heart } from "lucide-react";

const features = [
  { icon: <BookOpen size={28} />, title: "Deep Dive Classes", desc: "12-week passion-driven courses that spark curiosity and hands-on exploration." },
  { icon: <Users size={28} />, title: "Small Class Sizes", desc: "No more than 10 students per class for individualized learning." },
  { icon: <Leaf size={28} />, title: "Pick & Choose", desc: "Take one class or take five — flexible scheduling for homeschool families." },
  { icon: <Heart size={28} />, title: "Parent Friendly", desc: "Drop off your learner or stay — parents are always welcome." },
];

const Index = () => (
  <div>
    {/* Hero */}
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      <img src={heroBg} alt="Nevada desert landscape" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-bark/60" />
      <div className="relative z-10 text-center px-4 animate-fade-in">
        
        <h1 className="font-heading text-4xl md:text-6xl font-bold text-warm-white mb-4">
          Silver Sage Homeschool Hub
        </h1>
        <p className="font-body text-lg md:text-xl text-warm-white/90 italic mb-8 max-w-xl mx-auto">
          Empowering Homeschool Journeys
        </p>
        <div className="flex gap-4 justify-center flex-wrap">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-body font-bold text-base">
            <Link to="/classes">View Classes</Link>
          </Button>
        </div>
      </div>
    </section>

    {/* Our Mission */}
    <section className="py-20 px-4">
      <div className="container mx-auto max-w-3xl text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-6">Our Mission</h2>
        <p className="text-muted-foreground leading-relaxed text-lg">
          Silver Sage Homeschool Hub's mission is to enrich the lives of Nevada's homeschooling families by providing affordable, accessible, and engaging educational opportunities. Through passion-driven, project-based learning, we inspire curiosity, creativity, critical thinking, and personal growth while fostering meaningful connections and a supportive community where every child has the opportunity to explore their interests and thrive.
        </p>
      </div>
    </section>

    {/* Features */}
    <section className="py-16 px-4 bg-card">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((f) => (
            <div key={f.title} className="text-center p-6">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-terracotta-light text-primary mb-4">
                {f.icon}
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground mb-2">{f.title}</h3>
              <p className="text-sm text-muted-foreground">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="py-20 px-4 text-center">
      <h2 className="font-heading text-3xl font-bold text-foreground mb-4">Ready to Learn Wildly?</h2>
      <p className="text-muted-foreground mb-8 max-w-md mx-auto">
        Explore our classes and find the perfect fit for your curious learner.
      </p>
      <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 font-body font-bold">
        <Link to="/classes">Browse All Classes</Link>
      </Button>
    </section>
  </div>
);

export default Index;
